import React, { useEffect, useRef, useState } from "react";
import { TEMI, temaSalvato, applicaTema } from "@/lib/tema";
import { Check, Palette } from "lucide-react";

/**
 * Il proprio profilo, in alto a destra: chi sei e come vuoi vedere l'app.
 *
 * Il tema e' una scelta personale, scritta nel browser di chi la fa: due
 * persone sullo stesso gestionale possono vederlo in due modi diversi, e
 * nessuno lo cambia agli altri.
 */
export default function MenuProfilo({ user, avatar }) {
  const [aperto, setAperto] = useState(false);
  const [tema, setTema] = useState(temaSalvato);
  const riquadro = useRef(null);

  useEffect(() => {
    if (!aperto) return;
    const fuori = (e) => {
      if (riquadro.current && !riquadro.current.contains(e.target)) setAperto(false);
    };
    const esc = (e) => { if (e.key === "Escape") setAperto(false); };
    document.addEventListener("mousedown", fuori);
    document.addEventListener("keydown", esc);
    return () => {
      document.removeEventListener("mousedown", fuori);
      document.removeEventListener("keydown", esc);
    };
  }, [aperto]);

  const scegli = (codice) => { applicaTema(codice); setTema(codice); };

  return (
    <div className="relative" ref={riquadro}>
      <button type="button" onClick={() => setAperto((x) => !x)}
              data-testid="menu-profilo" title="Il tuo profilo e i colori dell'app"
              className="flex items-center gap-2 rounded px-1 py-0.5 hover:bg-slate-50 transition-colors">
        {avatar}
        <span className="hidden sm:flex flex-col items-start leading-tight max-w-[120px] lg:max-w-[160px]">
          <span className="text-sm font-semibold text-slate-900 truncate w-full">{user?.name}</span>
          <span className="text-[10px] uppercase tracking-widest text-slate-500">{user?.role}</span>
        </span>
      </button>

      {aperto && (
        <div className="absolute right-0 top-full mt-1 w-64 bg-white border border-slate-200
                        rounded-lg shadow-xl p-2 z-50"
             data-testid="pannello-profilo">
          <div className="px-2 py-1.5 border-b border-slate-100 mb-1 sm:hidden">
            <div className="text-sm font-semibold truncate">{user?.name}</div>
            <div className="text-[10px] uppercase tracking-widest text-slate-500">{user?.role}</div>
          </div>
          <div className="text-[10px] uppercase tracking-widest text-slate-400 px-2 py-1
                          flex items-center gap-1.5">
            <Palette className="w-3 h-3" /> Colori dell&apos;app
          </div>
          {TEMI.map((t) => (
            <button key={t.codice || "chiaro"} type="button" onClick={() => scegli(t.codice)}
                    data-testid={`tema-${t.codice || "chiaro"}`}
                    className={`w-full text-left px-2 py-2 rounded flex items-center gap-2.5 ${
                      tema === t.codice ? "bg-slate-100" : "hover:bg-slate-50"}`}>
              <span className="flex rounded overflow-hidden border border-slate-300 flex-shrink-0">
                {t.campione.map((c) => (
                  <span key={c} className="w-3 h-6" style={{ backgroundColor: c }} />
                ))}
              </span>
              <span className="min-w-0 flex-1">
                <span className="block text-sm font-medium truncate">{t.nome}</span>
                <span className="block text-[11px] text-slate-500 truncate">{t.nota}</span>
              </span>
              {tema === t.codice && <Check className="w-4 h-4 text-orange-500 flex-shrink-0" />}
            </button>
          ))}
          <p className="text-[10px] text-slate-400 px-2 pt-1.5 border-t border-slate-100 mt-1">
            Vale solo per te, su questo dispositivo.
          </p>
        </div>
      )}
    </div>
  );
}
